import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { ClearSession, Number, setFocus, setTitle, ReverseFormatDate, GetDate, OpenBase64Pdf } from "../Common/Common";
import Loader from '../Layout/Loader';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useRef } from 'react';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { getCommonData } from '../Common/CommanServices';
import { post } from '../Common/service';
import { API_SERVER } from '../../EnvConfig/env_config';

const RequestReceive = ({ open, setOpen }) => {
    const inputrefs = useRef([]);
    const cookies = new Cookies();
    const navigate = useNavigate();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const [RequestSheetNo, setRequestSheetNo] = useState("");
    const [requestNo, setrequestNo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [MenuText, setMenuText] = useState("Request Receive");

    const [Print, setPrint] = useState({
        SalesPersonCode: '',
        IsStockItemPrint: false,
        IsDistributionPrint: false,
    });
    const [saveData, setSaveData] = useState({
        RequestSheetNo: '',
        ItemDetails: [{}]
    });

    const [tableData, setTableData] = useState({})

    const handleGetRequestSheetData = (RequestSheetNo) => {
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token, LoginUserCode: loginCodeString, RequestSheetNo: RequestSheetNo,
        }
        post(`${API_SERVER}/api/Operation/GetReceiveRequestSheetDetails`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                setTableData({ ...res });
                setSaveData ({
                    ...saveData,
                    RequestSheetNo: RequestSheetNo,
                    RequestSheetDate: GetDate(0)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox("error", res.message, "");
            }
            setIsLoading(false);
        })
    };

    const handleDistributionPrint = (ID) => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true);
        post(`${API_SERVER}/api/Print/StockDistributionPrint`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'StockDistributionPrint_' + ID, '_blank');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }

    const handleStockPrint = (ID,) => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true);
        post(`${API_SERVER}/api/Print/StockItemPrint`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'StockItemPrint_' + ID, '_blank');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }


    const handleClearData = () => {
        setRequestSheetNo("")
        setTableData({});
        setFocus('txtRequisitionNo')
    }

    //Autocomplete array list
    let RequestNoArr = []
    for (let i = 0; i < requestNo.length; i++) {
        let mydata = requestNo[i]?.values
        RequestNoArr.push(mydata)
    };
    //API for Autocomplete
    const getRequestNo = () => {
        setrequestNo([])
        let temp = {
            Type: "GetUnReceivedRequestSheetNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let RequestNoDatalist = res.autoCompleteData || [];
                setrequestNo(RequestNoDatalist);
            } else {
                setrequestNo([]);
            }
        });
    }

    const handleOnChangeReceiveItem = (e, rowIndex) => {
        if (rowIndex < 0 || rowIndex >= tableData.length) {
            console.error("Invalid row Index:", rowIndex);
            return;
        }
        const receivedQuantity = +Number(e.target.value);
        
        const requestSheetQuantity = tableData.Data[rowIndex].RequestQuantity;
        console.log("requestQuantity", typeof (requestSheetQuantity))
        if (receivedQuantity > requestSheetQuantity) {
            AlertBox("error", "Received Quantity should not be greater than Request Quantity", "");
            const newItems = { ...tableData };
            newItems.Data[rowIndex].ReceivedQuantity = 0;
            setTableData(newItems)
            return;
        } else {
            const newItems = { ...tableData };
            newItems.Data[rowIndex].ReceivedQuantity = receivedQuantity;
            setTableData(newItems)
        }

        const newItems = [...tableData.Data];
        setSaveData({
            ...saveData,
            ItemDetails: newItems
        });
    };

    const SaveHandleConfirm = () => {
        Swal.fire({
            title: "Do you want to Receive these items ?",
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                handleSaveData()
            } 
        });
    }

    const handleSaveData = async () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);
        console.log("saveData", saveData)
        const data = {
            ...saveData, Token, LoginUserCode: loginCodeString, Source: 'WEB'
        }
        post(`${API_SERVER}/api/Operation/SaveReceiveRequestSheet`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, "");
                handleClearData();
                setPrint({
                    SalesPersonCode: res.salesPersonCode,
                    IsStockItemPrint: res.isStockItemPrint,
                    IsDistributionPrint: res.isDistributionPrint,
                })
                if (res.isReceiveRequestSheetPrint) {
                    setPrint({
                        RequestSheetNo: res.requestSheetNo,
                        IsReceiveRequestSheetPrint: res.isReceiveRequestSheetPrint,
                    });
                    OpenBase64Pdf(res.base64PDF, 'ReceiveRequestSheetPrint_' + res.requestSheetNo, '_blank');
                }
                handleClearData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, "");
                setIsLoading(false);
                setPrint({
                    SalesPersonCode: '',
                    IsStockItemPrint: false,
                    IsDistributionPrint: false,
                })
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
        })
    }

    useEffect(() => {
        setFocus('txtRequestNo');
        setTitle('RequestReceive', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500);
    },[])


    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtRequestReceiveDate')
                                                    };
                                                        
                                                }}
                                                label='Request No'
                                                placeholder="Request No"
                                                maxLength='50'
                                                options={RequestNoArr}
                                                id='txtRequestNo'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getRequestNo()}
                                                inputValue={RequestSheetNo}
                                                onInputChange={(event, newInputValue) => {
                                                    setRequestSheetNo(newInputValue);
                                                    handleGetRequestSheetData(newInputValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Request Receive Date </label>
                                            <DatePicker selected={ReverseFormatDate(GetDate(0))}
                                            disabled='disabled'
                                                id='txtRequestReceiveDate'
                                                className="form-control"
                                                placeholderText='Select Request Receive Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/*Requisition detail section Start*/}

                                    <>
                                        {tableData ?
                                            (
                                                <div className="col-lg-12 col-md-12 col-sm-12 mt-1">
                                                    <div className="heading-box">
                                                        <div className="heading d-flex gap-4">
                                                            <h6 className="m-0 font-weight-bold text-primary" >RequestSheet Item Details</h6>
                                                        </div>
                                                    </div>

                                                    <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                        <div className="table-responsive">
                                                            <table className="table-bordered" width="100%" cellSpacing="0">
                                                                <thead className="sticky-top">
                                                                    <tr>

                                                                        <th>RequestSheet No</th>
                                                                        <th>Sales Person</th>
                                                                        <th>Requisition Date</th>
                                                                        <th>Item</th>
                                                                        <th style={{ textAlign:"right" }}>RequestSheet Quantity</th>
                                                                        <th style={{ textAlign: "right" }}>Received Quantity<span className="Required">*</span></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {tableData.Data?.map((item, bodyIndex) => (

                                                                        <tr key={bodyIndex} >

                                                                            <td className='fields'>
                                                                                {item.RequestSheetNo}
                                                                            </td>
                                                                            <td className='fields'>
                                                                                {item.SalesPerson}
                                                                            </td>
                                                                            <td className='fields'>
                                                                                {item.RequestSheetDate}
                                                                            </td>
                                                                            <td className='fields'>
                                                                                {item.Item}
                                                                            </td>
                                                                            <td className='fields'>
                                                                                {item.RequestQuantity}
                                                                            </td>
                                                                            <td className='fields'>
                                                                                <input className="form-control" type='text'
                                                                                    id={`txtReceivedQuantity${bodyIndex + 1}`}
                                                                                    style={{ textAlign: "right" }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            let element = document.getElementById(`txtReceivedQuantity${bodyIndex + 2}`)
                                                                                            if (element) {
                                                                                                element.value = 0;
                                                                                                element.select();
                                                                                            }
                                                                                            else {
                                                                                                setFocus('btnSave');
                                                                                            }

                                                                                        };
                                                                                    }}
                                                                                    onFocus={(e) => { e.target.select() }}
                                                                                    
                                                                                    maxLength="10"
                                                                                    value={item.ReceivedQuantity}
                                                                                    onChange={(e) => { handleOnChangeReceiveItem(e, bodyIndex) }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    ))}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (<></>)}
                                    </>

                                    {/* Requisition detail section End*/}

                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSave' onClick={SaveHandleConfirm}>
                                                <i className="bi bi-check" /> Receive Request
                                            </button>

                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>

                                            {(Print?.IsStockItemPrint && Print?.SalesPersonCode) ?
                                                <>
                                                    <button className="button save-btn" onClick={() => handleStockPrint() } >
                                                        <i className="bi bi-printer" /> Stock Item Print
                                                    </button>
                                                </>
                                                :
                                                <></>
                                            }
                                            {(Print?.IsDistributionPrint && Print?.SalesPersonCode) ?
                                                <>
                                                    <button className="button save-btn" onClick={() => handleDistributionPrint()}>
                                                        <i className="bi bi-printer" /> Stock Distribution Print
                                                    </button>
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
         
        </main>
    )
}
export default RequestReceive